import { initializeApp } from "firebase/app";
  import {
    getAuth,
  } from "firebase/auth";
  import {
    getFirestore,
  } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDfQZ74qYLL6FTilQKCpfeWW6eOTawrWbM",
    authDomain: "my-website-1e7ad.firebaseapp.com",
    projectId: "my-website-1e7ad",
    storageBucket: "my-website-1e7ad.appspot.com",
    messagingSenderId: "223000683738",
    appId: "1:223000683738:web:a4cd4cfdf780b1baf031e3"
};

const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const db = getFirestore(app);

export { db };